import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import {
  ClinicDetails,
  ClinicSearchResults,
  GetClinicsPayload,
} from '@core/models';

import { Observable } from 'rxjs';

import { BaseService } from './base.service';

@Injectable({ providedIn: 'root' })
export class ClinicService extends BaseService {
  private http = inject(HttpClient);
  private clinics = 'clinics';

  constructor() {
    super();
  }

  public getClinics(
    payload: GetClinicsPayload,
  ): Observable<ClinicSearchResults> {
    const { latitude, longitude, limit, location, range, offset } = payload;
    const params = {
      ...(latitude && { latitude }),
      ...(longitude && { longitude }),
      ...(location && { location }),
      ...(range && { range }),
      ...(offset && { offset }),
      ...(limit && { limit }),
    };
    return this.http.get<ClinicSearchResults>(
      `${this.baseURL}/${this.clinics}`,
      {
        params,
      },
    );
  }

  public getClinicDetails(clinicId: string): Observable<ClinicDetails> {
    return this.http.get<ClinicDetails>(
      `${this.baseURL}/${this.clinics}/${clinicId}`,
    );
  }
}
